export enum ProductSugarOpt {
  NATURAL,
  SUGAR_5ML,
  SUGAR_10ML,
}

export const ProductSugarOptions: { id: ProductSugarOpt; name: string }[] = [
  { id: ProductSugarOpt.NATURAL, name: "Ngọt Tự Nhiên" },
  { id: ProductSugarOpt.SUGAR_5ML, name: "5ml Đường Phèn" },
  { id: ProductSugarOpt.SUGAR_10ML, name: "10ml Đường Phèn" },
];
